// extracted by css-extract-rspack-plugin
export default {"inputWrapper":"LanguageTab_inputWrapper__oB6ju"};